









import { uniqueId } from 'lodash-es'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class ToggleSwitch extends Vue {
  @Prop() item!: any
  @Prop() prop!: any
  @Prop() classes!: any

  name: string = 'ToggleSwitch'
  propId:string = uniqueId('toggle_')

  get onClass ():any {
    return this.item[this.prop] ? ' on' : ' off'
  }
}
